import { ReactNode } from "react";
import { SidebarProvider } from "@/components/ui/sidebar";
import { DashboardSidebar } from "@/components/dashboard-sidebar";
import { DashboardHeader } from "@/components/dashboard-header";
import { OrganizationProvider, useOrganization } from "@/context/OrganizationContext";
import { NoOrganizationState } from "@/components/organization/no-organization-state";

interface DashboardLayoutProps {
  children: ReactNode;
}

function DashboardShell({ children }: DashboardLayoutProps) {
  const { organization, graceMode, isLoading } = useOrganization();

  // Authenticated users without an organization (pending invite, removed
  // member, or failed provisioning) get a dedicated state instead of a broken
  // dashboard. Grace-mode (pre-backfill) accounts pass through normally.
  if (!isLoading && !organization && !graceMode) {
    return <NoOrganizationState />;
  }

  return (
    <SidebarProvider>
      <div className="flex min-h-screen w-full">
        <DashboardSidebar />
        <div className="flex flex-1 flex-col w-full overflow-x-hidden">
          <DashboardHeader />
          <main className="flex-1 p-6 w-full">
            <div className="w-full max-w-full">
              {children}
            </div>
          </main>
        </div>
      </div>
    </SidebarProvider>
  );
}

export function DashboardLayout({ children }: DashboardLayoutProps) {
  return (
    <OrganizationProvider>
      <DashboardShell>{children}</DashboardShell>
    </OrganizationProvider>
  );
}
